export default __webpack_public_path__ + "static/media/email-big.e9156d0f.svg";